import { ChangeDetectionStrategy, Component, computed, inject, OnInit, HostListener, signal } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthStore } from 'src/app/store/auth.store';
import { SiteStore } from 'src/app/store/site.store';
import { NotificationStore } from 'src/app/store/notification.store';
import { AppUpdatesStore } from 'src/app/store/app-updates.store';
import { SupportChatStore } from 'src/app/pages/support-chat/services/support-chat.store';
import { AvatarComponent } from "../../avatar/avatar.component";
import { SmLogoWhiteComponent } from '../../sm-logo/sm-logo-white.component';
import { SmLogoComponent } from "../../sm-logo/sm-logo.component";
import { BankAccountButtonComponent } from '../../bank-account-button/bank-account-button.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    SharedModule,
    SmLogoComponent,
    AvatarComponent,
    SmLogoWhiteComponent,
    BankAccountButtonComponent
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit {
  siteStore = inject(SiteStore);
  authStore = inject(AuthStore);
  notificationStore = inject(NotificationStore);
  appUpdatesStore = inject(AppUpdatesStore);
  supportChatStore = inject(SupportChatStore);

  // Total de no leídos mostrado sobre el avatar: suma de todos los badges de
  // notificación visibles en el drawer (notificaciones + actualizaciones +
  // chat de soporte). Mantener alineado con los badges de drawer.component.html.
  totalUnread = computed(() =>
    this.notificationStore.unreadCount() +
    this.appUpdatesStore.updatesUnread() +
    this.supportChatStore.unreadCount()
  );

  // Signal to track if user has scrolled
  isScrolled = signal(false);
  
  ngOnInit() {
    // Check initial scroll position
    this.checkScroll();
  }

  @HostListener('window:scroll')
  checkScroll() {
    // Update isScrolled signal based on window scroll position
    this.isScrolled.set(window.scrollY > 0);
  }
}
